export default class GameCommunicatorNovomatic {
  vm = undefined;
  source = undefined;

  constructor(vm) { this.vm = vm }

  init (iframeRef) {
    window.addEventListener('message', this.processGameMessage.bind(this));
    this.source = iframeRef;
  }
  postMessage (data) {
    switch (data) {
      case 'autoplayOff':
        data = { action: { name: 'autoplayOff' } };
        break;
      case 'stopGame':
        if (this.vm.isGameReady) this.vm.gameStopped();
        return;
      case 'resumeGame':
        this.vm.gameStarted();
        return;
    }
    data = JSON.stringify(data);
    console.log('GameCommunicator sent the following message: ', data);
    this.source.contentWindow.postMessage(data, '*');
  }
  processGameMessage (e) {
    switch (e.data) {
      case 'AUTOPLAY:FALSE':
        this.vm.autoplayStopped();
        break;
      case 'AUTOPLAY:TRUE':
        this.vm.autoplayStarted();
        break;
      case 'GAME_MODE:SPINNING':
        this.vm.isGameReady = false;
        break;
      case 'GAME_MODE:READY':
        if (this.vm.stopGame) this.vm.gameStopped();
        this.vm.isGameReady = true;
        break;
    }
  }
}
